/**
 * 登录记录值
 *
 * @type {string}
 */
const TokenKey = "ApiManageToken";

/**
 * 设置过期时间
 *
 * @type {number}
 */
const Expired = 120;

/**
 * 设置 Token
 *
 * @param token
 * @param key
 */
export function setToken(token, key) {
  /*now 获取当前时间 */
  const now = Date.now();
  let setTokenValue;
  /*1 分钟计算 (1000*60)  计算出总失效时间 (1000 * 60 * expired) now + 失效总分钟 算出最大存储时间*/
  if (Expired) {
    setTokenValue = JSON.stringify({
      data: token,
      expired: now + (1000 * 60 * Expired)
    });
  } else {
    setTokenValue = JSON.stringify({
      data: token,
      expired: now + (1000 * 60)
    });
  }
  return localStorage.setItem(key ? key : TokenKey, setTokenValue);
}

/**
 * 获取 Token
 *
 * @param key
 * @returns {string|void|*}
 */
export function getToken(key) {
  const now = Date.now();

  /* 获取 localStorage 存储信息 赋值给 source 对象 */
  const tokenValue = localStorage.getItem(key ? key : TokenKey);

  /* 如果key 有效  判断当前时间 是否超过 失效时间 */
  if (tokenValue) {

    const tokenValueJson = JSON.parse(tokenValue)

    if (now >= tokenValueJson.expired) {
      /* 超过失效时间 删除 储存内容  */
      return removeToken(key);
    } else {
      setToken(tokenValueJson.data, key);
      return tokenValueJson.data
    }
  }
  return '';
}

/**
 * 删除 token
 *
 * @param key
 */
export function removeToken(key) {
  return localStorage.removeItem(key ? key : TokenKey);
}